import React, { createContext, useContext } from 'react';

const FilterCondGameIdsContext = createContext<string[] | undefined>(undefined);

export function useFilterCondGameIds() {
  return useContext(FilterCondGameIdsContext);
}

export function FilterCondGameIdsProvider({
  gameIds,
  children,
}: {
  gameIds?: string[];
  children: React.ReactNode;
}) {
  return (
    <FilterCondGameIdsContext.Provider value={gameIds}>
      {children}
    </FilterCondGameIdsContext.Provider>
  );
}
